import React from 'react';
import { connect } from 'react-redux';
import TransactionStatus from './Components/TransactionStatus';
import EtherscanLink from './Components/EtherscanLink';

const mapStateToProps = (state) => {
  return {
    transactionsInProgress: Object.values(state.transactionsInProgress)
  };
};

const connectedTransactionsInProgress = ({transactionsInProgress}) => (
  <div className="c-transactions-in-progress">
    <h5>Transactions in progress</h5>
    {transactionsInProgress.length ? (
    <ul className="c-transactions-in-progress__list">
      {transactionsInProgress
        .reverse()
        .map((transaction) => (
        <li key={transaction.txHash}>
          {transaction.action}
          <TransactionStatus status={transaction.result}/>
          {transaction.result === false ? (
            <div className="c-transactions-in-progress__list-item-error">
              {transaction.validationMessage}
            </div>
          ) : null}
          <EtherscanLink txHash={transaction.txHash}/>
        </li>
      ))}
    </ul>
    ): <p>No transactions in progress</p>}
  </div>
);

const TransactionsInProgress = connect(mapStateToProps)(connectedTransactionsInProgress);

export default TransactionsInProgress;



// WEBPACK FOOTER //
// ./src/components/TransactionsInProgress.js